import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '恋爱', path: '/category/love' },
  { name: '动作', path: '/category/action' },
  { name: '奇幻', path: '/category/fantasy' },
  { name: '悬疑', path: '/category/suspense' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl text-primary-500">
              韩漫网
            </span>
            <span className="hidden sm:block text-xs text-foreground-500 mt-1">
              韩国漫画在线阅读
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/action"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl text-foreground-800 ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm py-2 whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category/action"
              className="mt-2 px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full text-center whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}